import actionTypes from './type';
import ApiServices from '~services';
import Utils from '~commons/utils';
import { DEFAULT_QUERY_WB } from '~commons/constants';
import Storage from '~storage';

export function fetchWaitingOfPlan(query = DEFAULT_QUERY_WB) {
  if (Storage?.user?.configs?.PageSizeWB > 30) {
    query.PageSize = Storage?.user?.configs?.PageSizeWB;
  }
  return async (dispatch) => {
    try {
      const { data } = await ApiServices.getWhiteBoardFour(query);
      return dispatch({
        data: data,
        type: actionTypes.FETCH_DATA,
      });
    } catch (error) {
      console.error('fetchWaitingOfPlan-ERR', error);
    }
    return dispatch({ data: [], type: actionTypes.FETCH_DATA });
  };
}
export function planedCont(contIds) {
  return async () => {
    try {
      const result = await ApiServices.createTaskJobGenerateByConts(contIds);
      if (result) {
        Utils.messageCustom('success', 'Lập kế hoạch công việc thành công!');
        return;
      }
    } catch (err) {
      console.error('createAssign', err);
    }
    Utils.messageCustom('error', 'Lập kế hoạch công việc thất bại!');
  };
}
export function loadMore(query = {}) {
  return async (dispatch) => {
    try {
      const { data } = await ApiServices.getWhiteBoardFour(query);
      return dispatch({
        data: data,
        type: actionTypes.LOAD_MORE_DATA,
      });
    } catch (error) {
      console.error('fetchWaitingOfPlan-loadMore-ERR', error);
    }
    return dispatch({ data: [], type: actionTypes.FETCH_DATA });
  };
}
export function updateQuery(query) {
  return (dispatch) => dispatch({ query, type: actionTypes.UPDATE_QUERY });
}
export function updateLoading(loading = false) {
  return (dispatch) => dispatch({ loading, type: actionTypes.UPDATE_LOADING });
}
export function updateSelected(selected = []) {
  return (dispatch) => dispatch({ selected, type: actionTypes.UPDATE_SELECTED });
}
export function updateSelectedRowKey(selected = []) {
  return (dispatch) => dispatch({ selected, type: actionTypes.UPDATE_SELECTED_ROW_KEY });
}
export function updateOne(data) {
  return (dispatch) => dispatch({ data, type: actionTypes.UPDATE_ONE_DATA });
}
